// Gemensamma, sanningsenliga statushjälpare för Kunder-listan och Kund 360.
// Följer arbetsorderns semantik: kundfas (demo.status), Widget På/Pausad och
// runtime (runtime_source: handymen=Äldre kärna, blueprint=Gemensam kärna).

// Kundfas — demo.status utan datamigrering. `active` visas som "Kund".
export const KUNDFAS = {
  demo: { label: "Demo", cls: "bg-[#3A8A98]/10 border-[#3A8A98]/30 text-[#255E69]" },
  pilot: { label: "Pilot", cls: "bg-amber-50 border-amber-200 text-amber-700" },
  active: { label: "Kund", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" },
  archived: { label: "Arkiverad", cls: "bg-gray-100 border-gray-200 text-gray-500" },
};

export const KUNDFAS_UNSET = {
  label: "Ej angiven",
  cls: "bg-gray-50 border-gray-200 text-gray-500",
};

export function kundfas(demoStatus) {
  if (!demoStatus) return { key: "_unset", ...KUNDFAS_UNSET };
  const hit = KUNDFAS[demoStatus];
  if (hit) return { key: demoStatus, ...hit };
  return { key: demoStatus, label: demoStatus, cls: KUNDFAS_UNSET.cls };
}

// Widget På/Pausad — konfigurationsstatus, inte "verifierat live".
export function widgetStatus(active) {
  return active
    ? { label: "Widget På", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" }
    : { label: "Widget Pausad", cls: "bg-gray-50 border-gray-200 text-gray-500" };
}

// Runtime — sanningsenlig lagringstoken. Vid okänt/läsfel: "Kunde inte kontrollera".
export function runtimeLabel(runtimeSource) {
  if (runtimeSource === "blueprint") {
    return { label: "Gemensam kärna", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" };
  }
  if (runtimeSource === "handymen") {
    return { label: "Äldre kärna", cls: "bg-slate-100 border-slate-200 text-slate-700" };
  }
  return { label: "Kunde inte kontrollera", cls: "bg-red-50 border-red-200 text-red-700" };
}

// Sanningsenlig EFFEKTIV runtime enligt backend (_derive_runtime):
//  blueprint  = gemensam kärna vald + tillåten (kör chatten)
//  legacy     = gemensam kärna ej vald → handymen-kärnan kör chatten (inte "bara fallback")
//  blocked    = vald men ej tillåten → SAFE_ERROR: chatten svarar neutralt fel, inget kör
export function runtimeState(activeRuntime, runtimeHealth) {
  if (runtimeHealth === "error" || activeRuntime === "blocked") {
    return { label: "Blockerad", cls: "bg-red-50 border-red-200 text-red-700" };
  }
  if (activeRuntime === "blueprint") {
    return { label: "Gemensam kärna", cls: "bg-emerald-50 border-emerald-200 text-emerald-700" };
  }
  if (activeRuntime === "legacy") {
    return { label: "Äldre kärna", cls: "bg-slate-100 border-slate-200 text-slate-700" };
  }
  return { label: "Kunde inte kontrollera", cls: "bg-gray-50 border-gray-200 text-gray-500" };
}
